import { ApplicationState } from 'app/types-store';
import { connect } from 'react-redux';
import { RiskMatrixProps } from 'app/components/risk-matrix';
import { transformToComponentFormat, preselectedRiskMatrixValues } from 'app/area/case/features/risk-matrix/risk-matrix-definition';
import { actionCreators } from 'app/area/case/draft/actions';
import get from 'lodash/get';

const getDefinitionFromStore = (state: ApplicationState, uiEngineProps: any) => {
  const hostProps = uiEngineProps && uiEngineProps.hostProps();
  const applicationId = hostProps.applicationId;
  return get(state, uiEngineProps.statePath).riskMatrixDefinitions[applicationId];
};

export const withRiskMatrix = (component: any, uiEngineProps: any) => {

  const stateToProps = (state: ApplicationState): Partial<RiskMatrixProps> => {
  const storeDefinition = getDefinitionFromStore(state, uiEngineProps);

  const definition =  transformToComponentFormat(storeDefinition, uiEngineProps);
    return {
      riskMatrixDefinition: definition,
      preselectedValues: preselectedRiskMatrixValues(get(state, uiEngineProps.statePath), uiEngineProps, definition)
    };
  };
  
  const dispatchToProps = (dispatch: any): Partial<RiskMatrixProps> => {
    const dataPath = uiEngineProps.resolveContext.path;
    const changeAxisValue = (v: number, axisCodetableId: number) => {
      const immediateSave = uiEngineProps.componentDescriptor.properties 
                         && uiEngineProps.componentDescriptor.properties.immediateSaveOnValueChange;
      const axisComponent = uiEngineProps.componentDescriptor.children.find(c => c.codetable === axisCodetableId);
      dispatch(actionCreators.valueChanged(dataPath, axisComponent.dataTag, [{ value: v}], !!immediateSave));
      return;
    };

    return {
      onSelectedXChanged: changeAxisValue,
      onSelectedYChanged: changeAxisValue
    };
  };

  return connect<any, any, any>(stateToProps, dispatchToProps)(component);
};
